import { defineMessages } from 'react-intl';

/** The copy of the Outreach states (design "Outreach Momentum" t6). */
export const stateMessages = defineMessages({
  freeEyebrow: { id: 'app.outreach.live.state.free.eyebrow', defaultMessage: 'Free plan and trial' },
  freePreview: { id: 'app.outreach.live.state.free.preview', defaultMessage: 'Preview' },
  freeTitle: {
    id: 'app.outreach.live.state.free.title',
    defaultMessage: 'Plug found {count, plural, one {# curator} other {# curators}} who fit {song}.',
  },
  freeBody: {
    id: 'app.outreach.live.state.free.body',
    defaultMessage: 'Pitching starts on a paid plan. Plug writes each pitch and sends it from your mailbox.',
  },
  fit: { id: 'app.outreach.live.state.free.fit', defaultMessage: 'Fit {score}' },
  seeAll: { id: 'app.outreach.live.state.free.seeAll', defaultMessage: 'See all {count}' },
  seePlans: { id: 'app.outreach.live.state.free.seePlans', defaultMessage: 'See plans' },
  stoppedEyebrow: { id: 'app.outreach.live.state.stopped.eyebrow', defaultMessage: 'Sending stopped' },
  stoppedChip: { id: 'app.outreach.live.state.stopped.chip', defaultMessage: 'Reconnect' },
  stoppedTitle: {
    id: 'app.outreach.live.state.stopped.title',
    defaultMessage: 'Your mailbox signed out. {count, plural, one {# pitch waits} other {# pitches wait}}.',
  },
  stoppedBody: {
    id: 'app.outreach.live.state.stopped.body',
    defaultMessage:
      '{mailbox} refused the sign-in. Nothing is lost: Plug sends the waiting pitches when you connect it again. Replies still arrive.',
  },
  stoppedBodyNoMailbox: {
    id: 'app.outreach.live.state.stopped.bodyNoMailbox',
    defaultMessage:
      'Your mailbox refused the sign-in. Nothing is lost: Plug sends the waiting pitches when you connect it again. Replies still arrive.',
  },
  memberNote: {
    id: 'app.outreach.live.state.stopped.member',
    defaultMessage: 'Only the workspace owner can reconnect the mailbox.',
  },
  reconnect: { id: 'app.outreach.live.state.stopped.reconnect', defaultMessage: 'Reconnect mailbox' },
  noFitEyebrow: { id: 'app.outreach.live.state.noFit.eyebrow', defaultMessage: 'No good fit yet' },
  noFitTitle: { id: 'app.outreach.live.state.noFit.title', defaultMessage: 'Plug keeps looking for you.' },
  noFitBody: {
    id: 'app.outreach.live.state.noFit.body',
    defaultMessage:
      'It found no curator with an email who fits {song} well enough. Every night it checks new playlists and new contacts, and it tells you at once when it finds someone.',
  },
  noFitLastCheck: {
    id: 'app.outreach.live.state.noFit.lastCheck',
    defaultMessage:
      'Next check tonight. Last check: {count, plural, one {# playlist} other {# playlists}}, 0 good fits.',
  },
  noFitAddGenres: { id: 'app.outreach.live.state.noFit.addGenres', defaultMessage: 'Add genres to your sound' },
  noFitImport: { id: 'app.outreach.live.state.noFit.import', defaultMessage: 'Import your own contacts' },
});
